module.exports = __webpack_public_path__ + "img/3.8fdf50e3.png";